import type { QuoteRow } from "@/hooks/useQuotes";
import { QuoteDrawer } from "./drawer/QuoteDrawer";

interface QuoteDetailPanelProps {
  quote: QuoteRow | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onContactClick?: (contactId: string) => void;
  /** After Delete draft succeeds. Defaults to onOpenChange(false). */
  onDeleted?: () => void;
}

/**
 * The quote drawer (#1559). Mounted only while open and keyed by quote id, so
 * each open starts from the saved quote and a closed drawer keeps no edits.
 */
export function QuoteDetailPanel({ quote, open, onOpenChange, onContactClick, onDeleted }: QuoteDetailPanelProps) {
  if (!open || !quote) return null;
  return (
    <QuoteDrawer
      key={quote.id}
      quote={quote}
      onOpenChange={onOpenChange}
      onContactClick={onContactClick}
      onDeleted={onDeleted ?? (() => onOpenChange(false))}
    />
  );
}
